import type {Dispatch, ThunkAction} from 'src/reducers';
import type {
  SmartScheduler,
  SmartSchedulerApi,
} from 'src/types/scheduler/smartScheduler';
import {
  getDefaultSmartSchedulerFormData,
  parseSmartSchedulerNode,
} from 'src/components/scheduler/smart-scheduler/helper';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import * as reduxApiBff from 'src/utils/redux-api-bff';


export const SET_SMART_SCHEDULER_TASK_NODE = 'SET_SMART_SCHEDULER_TASK_NODE';

const defaultNode = {
  ...getDefaultNodeScheduleState({}),
  date_field: undefined,
  time_field: undefined,
  recurring_rule: null,
  frequency_limit_settings: {
    skip: false,
  },
  task: {
    params: {
      ...getDefaultSmartSchedulerFormData(),
    },
  },
};

export type SmartSchedulerActions = SetSmartSchedulerTaskNodeAction;

export type SetSmartSchedulerTaskNodeAction = {
  type: typeof SET_SMART_SCHEDULER_TASK_NODE;
  payload: SmartScheduler;
};

const setSmartSchedulerTaskNode = (
  payload: SmartScheduler,
): SetSmartSchedulerTaskNodeAction => ({
  type: SET_SMART_SCHEDULER_TASK_NODE,
  payload,
});

export const updateSmartSchedulerTaskNode = (
  payload: SmartScheduler,
): SetSmartSchedulerTaskNodeAction => ({
  type: SET_SMART_SCHEDULER_TASK_NODE,
  payload,
});

export const resetSmartSchedulerTaskNode =
  (): SetSmartSchedulerTaskNodeAction => ({
    type: SET_SMART_SCHEDULER_TASK_NODE,
    payload: defaultNode,
  });

export const getSmartSchedulerTaskNode: (id: string) => ThunkAction<unknown> =
  (id) => async (dispatch: Dispatch) => {
    const fetchedNodeResponse = await dispatch(
      reduxApiBff.get<SmartSchedulerApi>(`node/composite`, {
        node_id: id,
      }),
    );

    const parsedSmartSchedulerNode = parseSmartSchedulerNode(
      fetchedNodeResponse.body,
    );
    return dispatch(setSmartSchedulerTaskNode(parsedSmartSchedulerNode));
  };
